const state = {
  list: {FName: 0, FCode: 1, FCode1: 2, FCode2: 3}
}

const mutations = {
  increment (state, FKey, FValue) {
    state.list[FKey] = FValue
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bosbill.js